"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CianMortgageButton = require("./CianMortgageButton");
Object.keys(_CianMortgageButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CianMortgageButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CianMortgageButton[key];
    }
  });
});